export const HISTORICO_PRESETS = {
  LAST_7_DAYS: 'last7',
  THIS_MONTH: 'thisMonth',
  LAST_MONTH: 'lastMonth',
  YTD: 'ytd',
};

export function toISODate(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function cloneDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function getPresetRange(presetId, now = new Date()) {
  const today = cloneDate(now);
  const todayISO = toISODate(today);

  if (presetId === HISTORICO_PRESETS.LAST_7_DAYS) {
    const desde = cloneDate(today);
    desde.setDate(desde.getDate() - 6);
    return { desde: toISODate(desde), hasta: todayISO };
  }

  if (presetId === HISTORICO_PRESETS.THIS_MONTH) {
    const desde = new Date(today.getFullYear(), today.getMonth(), 1);
    return { desde: toISODate(desde), hasta: todayISO };
  }

  if (presetId === HISTORICO_PRESETS.LAST_MONTH) {
    const year = today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear();
    const month = today.getMonth() === 0 ? 11 : today.getMonth() - 1;
    const desde = new Date(year, month, 1);
    const hasta = new Date(year, month + 1, 0);
    return { desde: toISODate(desde), hasta: toISODate(hasta) };
  }

  if (presetId === HISTORICO_PRESETS.YTD) {
    const desde = new Date(today.getFullYear(), 0, 1);
    return { desde: toISODate(desde), hasta: todayISO };
  }

  return null;
}

export function formatRangeLabel(desdeISO, hastaISO) {
  if (!desdeISO || !hastaISO) return '';
  const [y1, m1, d1] = desdeISO.split('-');
  const [y2, m2, d2] = hastaISO.split('-');
  if (!y1 || !m1 || !d1 || !y2 || !m2 || !d2) return '';
  return `${d1}/${m1}/${y1} - ${d2}/${m2}/${y2}`;
}

export function filterMesSeriesByRange(rawData, desdeISO, hastaISO) {
  if (!rawData || !desdeISO || !hastaISO) return rawData;

  const desdeMes = String(desdeISO).slice(0, 7);
  const hastaMes = String(hastaISO).slice(0, 7);
  const monthlyKeys = [
    'sesiones_por_mes',
    'citas_por_mes',
    'horas_por_mes',
    'clientes_por_mes',
    'tareas_por_mes',
    'oportunidades_por_mes',
    'facturacion_por_mes',
  ];

  const output = { ...rawData };
  monthlyKeys.forEach((key) => {
    if (Array.isArray(output[key])) {
      output[key] = output[key].filter((item) => {
        const mes = item?.mes;
        return typeof mes === 'string' && mes >= desdeMes && mes <= hastaMes;
      });
    }
  });

  return output;
}

export function getHistoricoStorageKey(userId) {
  return `historico_filters_user_${userId}`;
}
